import React, {useMemo} from 'react';

import {useUserTypes} from 'src/hooks/dictionaries';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';

import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';

type Props = {
    userType: string,
    setUserType: (typeCode: string) => void,
    disabled?: boolean,
    excludeNoAccess?: boolean,
};

export const NO_ACCESS_USER_TYPE_CODE = 'T_NA';
export const LICENSED_USER_TYPE_CODE = 'T_LC';

const getAvailableTypes = (userTypes: DictionaryItem[], excludeNoAccess: boolean): DictionaryItem[] => {
    return excludeNoAccess
        ? userTypes.filter(({code}) => code !== NO_ACCESS_USER_TYPE_CODE)
        : userTypes;
};

export const UserTypeSuggest = ({userType, setUserType, disabled, excludeNoAccess}: Props) => {
    const {userTypes} = useUserTypes();
    const availableTypes = useMemo(() => getAvailableTypes(userTypes, !!excludeNoAccess), [
        userTypes,
        excludeNoAccess,
    ]);

    return (
        <ComboBox disabled={disabled} value={userType} onChange={setUserType}>
            {availableTypes.map(({code, description}) => (
                <ComboboxItem key={code} caption={description} value={code}/>
            ))}
        </ComboBox>
    );
};
